// import { createStyles } from '@material-ui/core';

export default {
  palette: {
    primary: {
      main: '#eb0045',
    },
  },
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: '1em',
      },
    },
    MuiFormLabel: {
      root: {
        fontSize: '16px',
      },
    },
    MuiCircularProgress: {
      root: {
        colorPrimary: '#eb0045',
        colorSecondary: '#fff',
      },
    },
    MuiPagination: {
      root: {
        colorPrimary: '#eb0045',
      },
    },
    MuiIconButton: {
      root: {
        colorPrimary: '#eb0045',
      },
    },
  },
  typography: {
    fontFamily: ['"Exo 2"', 'sans-serif'].join(','),
  },
};
